import { createFileRoute } from '@tanstack/react-router';

import { AuthView } from 'views/AuthView';

export const Route = createFileRoute('/_auth/auth')({
  component: AuthView,
});
